import Address from "./Address";
import { CoreDataContext } from "../components/Layout";
import CustomLink from "./CustomLink";
import HandsIcon from "./HandsIcon";
import classNames from "classnames";
import gridStyle from "./Grid.module.css";
import styles from "./Footer.module.css";
import { useContext } from "react";

export default function Footer({ theme = "dark" }) {
  const { socialLinks } = useContext(CoreDataContext);

  return (
    <footer className={classNames(styles.Footer, gridStyle.grid)}>
      <div className={styles.col1}>
        <div className={styles.heading}>Get in touch</div>
        <HandsIcon theme={theme} />
      </div>
      <div className={styles.col2}>
        <div className={styles.intro}>
          If you would like to chat about a project big or small, please get in
          touch
        </div>
        <CustomLink
          href="mailto:thecrew@wearecrew.com"
          className={styles.email}
        >
          thecrew@wearecrew.com
        </CustomLink>
        <Address className={styles.address} />
        <div className={styles.links}>
          <CustomLink href={socialLinks.twitterUrl} className={styles.link}>
            X
          </CustomLink>
          <CustomLink href={socialLinks.linkedinUrl} className={styles.link}>
            Linkedin
          </CustomLink>
          <CustomLink href={socialLinks.vimeoUrl} className={styles.link}>
            Vimeo
          </CustomLink>
          <CustomLink href={socialLinks.instagramUrl} className={styles.link}>
            Instagram
          </CustomLink>
        </div>
      </div>
    </footer>
  );
}
